module.exports = __webpack_public_path__ + "img/20210730_213353.d5eb0bb8.jpg";